import { LoyaltyNotSupportedError } from "../../errors";
import validateConfig from "../validateConfig";
const isLoyaltyAvailable = (config) => {
    try {
        validateConfig(config);
        return true;
    }
    catch (error) {
        if (error instanceof LoyaltyNotSupportedError) {
            return false;
        }
        throw error;
    }
};
export default isLoyaltyAvailable;
